// extracted by mini-css-extract-plugin
export default {"breed_pill":"BreedPills_breed_pill__bVa+c","spin":"BreedPills_spin__Wj4zQ"};